import createReducer from "./createReducer";

export const MODAL_ACTIONS = {
	OPEN_MODAL: "OPEN_MODAL",
	CLOSE_MODAL: "CLOSE_MODAL",
};

const INITIAL_STATE = {
	isOpen: false,
	modalType: null,
	modalOptions: {},
};

export function openModal(modalType, modalOptions = {}){
	return dispatch => dispatch({
		type: MODAL_ACTIONS.OPEN_MODAL,
		payload: { modalType, modalOptions },
	});
}

export function closeModal(){
	return dispatch => dispatch({
		type: MODAL_ACTIONS.CLOSE_MODAL,
		payload: {},
	});
}

const HANDLERS = {
	[MODAL_ACTIONS.OPEN_MODAL]: setModalOpen,
	[MODAL_ACTIONS.CLOSE_MODAL]: setModalClosed,
};

function setModalOpen(state, action){
	return {
		isOpen: true,
		modalType: action.payload.modalType,
		modalOptions: action.payload.modalOptions,
	};
}

function setModalClosed(state, action){
	return {
		isOpen: false,
		modalType: null,
		modalOptions: {},
	};
}

export const REDUCERS = {
	setModalOpen,
	setModalClosed,
};

export default createReducer(INITIAL_STATE, HANDLERS);
